import advertiserRepository from '@/legacy/repositories/advertiserRepository'
import storeRepository from '@/legacy/repositories/storeRepository'
import * as types from '@/legacy/store/mutation-types'
import { config } from '@/lib/helpers'
import { stripe } from '@/lib/helpers/stripe'

export default {
  namespaced: true,
  state: {
    paymentPaid: false,
    stripe: null,
    error: null,
    isLoading: null,
    elements: null,
    minimumFee: null,
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    isPaymentPaid: (state) => state.paymentPaid,
    elements: (state) => state.elements,
    minimumFee: (state) => state.minimumFee,
  },
  mutations: {
    [types.SET_ERROR]: (state, value) => (state.error = value),
    [types.SET_LOADING]: (state, value) => (state.isLoading = value),
    SET_PAYMENT_PAID_STATUS: (state, value) => (state.paymentPaid = value),
    [types.SET_DATA]: (state, { elements, setupIntentId, minimumFee }) => {
      state.elements = elements
      state.setupIntentId = setupIntentId
      state.minimumFee = minimumFee
    },
  },
  actions: {
    async setupStripe({ commit }, { storeId, authorization }) {
      try {
        commit(types.SET_LOADING, true)
        const { data } = await advertiserRepository.getPaymentSetupDetails(authorization, storeId)
        const elements = stripe.elements({ clientSecret: data.setupSecret })
        const card = elements.create('payment')
        card.mount('#payment-element')

        commit(types.SET_DATA, {
          elements,
          setupIntentId: data.setupIntentId,
          minimumFee: data.minimumFee,
        })
      } catch (e) {
        commit(types.SET_ERROR, e)
      } finally {
        commit(types.SET_LOADING, false)
      }
    },
    async sendPayment({ state, commit }) {
      try {
        commit(types.SET_LOADING, true)
        const { error } = await stripe.confirmSetup({
          elements: state.elements,
          confirmParams: {
            return_url: config.stripeReturnUrl,
          },
        })

        if (error) {
          commit(types.SET_ERROR, error)
        }
      } catch (err) {
        commit(types.SET_ERROR, err)
      } finally {
        commit(types.SET_LOADING, false)
      }
    },
    async confirmPayment({ commit, rootState }, { setupIntentId, advertiserId }) {
      try {
        commit(types.SET_LOADING, true)
        await storeRepository.confirmSetup(setupIntentId, advertiserId, rootState.user.token)
        return commit('SET_PAYMENT_PAID_STATUS', true)
      } catch (err) {
        if (err.status) {
          switch (err.status) {
            case 'requires_payment_method':
              return commit(types.SET_ERROR, 'Payment failed. Please try another payment method.')
            default:
              return commit(
                types.SET_ERROR,
                "The payment didn't go through. Please contact your bank or the card issuer.",
              )
          }
        }
        commit(types.SET_ERROR, err)
      } finally {
        commit(types.SET_LOADING, false)
      }
    },
  },
}
